import AxiosConfig from '../../../config/AxiosConfig';
import { useDispatch } from 'react-redux';
import { setSnackBar } from '../../states/app/staticSlice';

function useTemplateDelete() {
  const dispatch = useDispatch();
  const deleteTemplate = async (formData) => {
    try {
      const response = await AxiosConfig.create('delete', `/templates/delete`)
        .call(formData)
        .getResponseData();
      if (response?.status > 300) {
        const messageError = `Error ${response?.status} - ${response?.message} in useTemplateDelete`;
        dispatch(
          setSnackBar({ open: true, message: messageError, color: 'error' })
        );
      }
      return response;
    } catch (err) {
      console.error('Failed to delete template:', err);
      throw new Error(`Delete template failed: ${err.message}`);
    }
  };

  return {
    deleteTemplate,
  };
}

export default useTemplateDelete;
